<div class="zone-selector">
    <label class="zone-label" [ngStyle]="{'visibility': value ? 'visible' : 'hidden'}">
        {{ (multiple ? 'zones-selector.zones' : 'zones-selector.zone') | translate | capitalizeFirst }}
    </label>

    <p-multiSelect *ngIf="multiple === true" [options]="availableZones" [(ngModel)]="value" optionLabel="displayValue" optionValue="value"
        [disabled]="disabled" styleClass="w-full" [placeholder]="'zones-selector.zones' | translate | capitalizeFirst"
        (onChange)="onSelectChange($event.value)" (onClear)="onSelectChange([])" appendTo="body">
    </p-multiSelect>

    <p-dropdown *ngIf="multiple === false" [options]="availableZones" [(ngModel)]="value" optionLabel="displayValue" optionValue="value"
        [disabled]="disabled" [showClear]="true" [filter]="true" filterBy="displayValue" styleClass="w-full"
        [placeholder]="'zones-selector.zone' | translate | capitalizeFirst" (onChange)="onSelectChange($event.value)"
        (onClear)="onSelectChange(null)" appendTo="body">
    </p-dropdown>
</div>